import type { Note } from "@/core/types";

type NoteContentV5V6 = {
  communication_type: string;
  reason_for_communication: string[];
  reason_for_communication_other?: string;
};

export function getSubTitle(note: Note): string | null {
  // ICA no-show without a completed date has no subtitle regardless of version
  if (
    note.note_type === "Initial Clinical Assessment" &&
    note.content?.patient_no_show_array &&
    !note.completed_date_time
  ) {
    return null;
  }

  if (note.version === 5 || note.version === 6) {
    const content = note.content as NoteContentV5V6;
    const communicationReason = content.reason_for_communication
      .map((reason) => {
        if (reason === "Other (open text)" && content.reason_for_communication_other) {
          return `Other: ${content.reason_for_communication_other}`;
        }

        return reason;
      })
      .join(", ");

    return `${content.communication_type} - ${communicationReason}`;
  }

  return null;
}
